export function initHeroScroll() {
  const editMode = document.querySelector(".edit-mode");
  if (editMode) {
    return;
  }
  const hero = document.querySelector(".hero");

  function updateHero() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    const viewportHeight = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    const scrollThreshold = viewportHeight * 0.9; // 70% of viewport height
    const mobileProgress = Math.min(scrollY / scrollThreshold, 1);
    const opacity = 1 - mobileProgress;
    const translateY = Math.round(Math.min(mobileProgress * 200, 200)); // Rounded to nearest pixel

    hero.style.setProperty("--scroll-opacity", opacity);
    hero.style.setProperty("--scroll-translate", `${translateY}px`);
  }

  if (hero) {
    ["scroll", "touchmove", "resize"].forEach(eventType => {
      window.addEventListener(eventType, updateHero, { passive: true });
    });

    updateHero();
  }
}
